define(["require", "exports", "ts-vector-math"], function (require, exports, ts_vector_math_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Helper = (function () {
        function Helper() {
        }
        Helper.Round = function (value, decimalPlace) {
            if (decimalPlace === 0)
                return Math.round(value);
            var data = value.toString().split('e');
            value = Math.round(+(data[0] + 'e' + (data[1] ? (+data[1] + decimalPlace) : decimalPlace)));
            data = value.toString().split('e');
            return +(data[0] + 'e' + (data[1] ? (+data[1] - decimalPlace) : -decimalPlace));
        };
        Helper.Vector2 = (function () {
            function class_1() {
            }
            class_1.GetMaxSize = function (size, maxWidth) {
                if (size.x > maxWidth) {
                    var result = new ts_vector_math_1.Vector2();
                    result.x = maxWidth;
                    var ratio = size.x / size.y;
                    result.y = maxWidth / ratio;
                    return result;
                }
                return new ts_vector_math_1.Vector2([size.x, size.y]);
            };
            class_1.Min = function (vectorA, vectorB) {
                var result = new ts_vector_math_1.Vector2();
                result.x = Math.min(vectorA.x, vectorB.x);
                result.y = Math.min(vectorA.y, vectorB.y);
                return result;
            };
            class_1.Max = function (vectorA, vectorB) {
                var result = new ts_vector_math_1.Vector2();
                result.x = Math.max(vectorA.x, vectorB.x);
                result.y = Math.max(vectorA.y, vectorB.y);
                return result;
            };
            return class_1;
        }());
        return Helper;
    }());
    exports.Helper = Helper;
});
//# sourceMappingURL=Helper.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Shared/Helper.js
// module id = 58
// module chunks = 0